module.exports = __webpack_public_path__ + "img/cert-edit.b8bb2a77.svg";